import { ColumnRankRowSpan, ColumnMoveRowSpan, ColumnNameRowSpan, ColumnNocRowSpan, ColumnEstOverallRowSpan, ColumnMarksColspan, ColumnRacePointsRowSpan, ColumnCrew, ColumnEr, ColumnEarnedWinsRowSpan, ColumnSumaryRace, ColumnSummaryRank, ColumnRacesColspan, ColumnExtendedResultRowSpan, ColumnResultRowSpan, ColumnQualificationRowSpan, ColumnSummaryRankRowSpan } from "./TableColumns";
import { ColumnName, ColumnRank, ColumnNoc, ColumnQualification } from "components/common/TableColumns"
import Label from 'components/general/Label';

export function RaceColumns(type, currentLeg, marks) {
    return [
        ColumnRankRowSpan({}),
        ColumnMoveRowSpan({ currentLeg: currentLeg }),
        ColumnNocRowSpan({}),
        ColumnNameRowSpan({ type: type }),
        ColumnMarksColspan({ marks: marks }),
        ColumnRacePointsRowSpan({}),
        ColumnEstOverallRowSpan({}),
    ];
}



export function CurrentLeadersColumns(type, isLeg1) {

    return [
        ColumnRank({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ...(type === 'T' ? [ColumnCrew(false)] : [ColumnName({ label: "HeaderBoat", disableSort: true })]),
        ...(isLeg1 ? leg1Columns() : legsColumns())
    ];
}


function leg1Columns() {
    return [
        ColumnEr({ id: 'er1', label: "HeaderStartLinePosition", code: "startPosition" }),
        ColumnEr({ id: 'er2', label: "HeaderDistanceToStartLine", code: "startDistance" }),
        ColumnEr({ id: 'er3', label: "HeaderSpeedAtStart", code: "startSpeed" }),
    ]
}

function legsColumns() {
    return [
        ColumnEr({ id: 'er1', label: "HeaderTimeBehind", code: "timeBehind" }),
        ColumnEr({ id: 'er2', label: "HeaderDistanceBehind", code: "distanceBehind" }),
        ColumnEr({ id: 'er3', label: "HeaderSpeed", code: "speed" }),

    ]

}

export function SummaryColumnsFinal(dataUnits) {
    let raceColumns = []
    dataUnits?.phase?.units.map((unit, index) =>
        raceColumns.push(ColumnSumaryRace(unit?.code, index))
    );

    return [
        ColumnSummaryRankRowSpan("FNL"),
        ColumnNocRowSpan({ disableSort: true }),
        ColumnNameRowSpan({ disableSort: true }),
        ColumnEarnedWinsRowSpan("FNL"),
        {
            id: 'Races',
            Header: <Label data="HeaderRaces" />,
            headerClassName: "text-center",
            columns: raceColumns
        }
    ]
}

export function SummaryColumnsSemiFinal(dataUnits, filter) {
    let raceColumns = []
    dataUnits?.phase?.units.filter(u => u.code.includes(filter))
        ?.sort((a, b) => a.code > b.code ? 1 : -1)
        ?.map((unit, index) =>
            raceColumns.push(ColumnSumaryRace(unit?.code, index))
        );
    return [
        ColumnSummaryRankRowSpan("SFNL"),
        ColumnNocRowSpan({ disableSort: true }),
        ColumnNameRowSpan({ disableSort: true }),
        ColumnEarnedWinsRowSpan("SFNL"),
        {
            id: 'Races',
            Header: <Label data="HeaderRaces" />,
            headerClassName: "text-center",
            columns: raceColumns
        },
        ColumnQualificationRowSpan({})
    ]
}

export function OverallColumns(type, races) {
    return [
        ColumnRankRowSpan({}),
        ColumnNocRowSpan({}),
        ColumnNameRowSpan({ type: type }),
        ColumnRacesColspan({ races: races }),
        ColumnExtendedResultRowSpan({ id: "TotaLPoints", label: "HeaderTotalPointsAbbrv", code: "TOTAL_PTS" }),
        ColumnResultRowSpan({}),
        ColumnQualificationRowSpan({})
    ]
}

export function MedalSeriesColumns(type, races, isMedalSeries, isMobile) {
    const nameHeaderClassName = !isMobile ? "text-start w-40 align-middle" : "text-start w-30 align-middle";
    const racesHeaderClassName = !isMobile ? "text-end w-15" : "text-end w-5"
    const qualHeaderClassName = !isMobile ? "w-5 current qual_background" : "w-5 current qual_background";
    const qualClassName = !isMobile ? "qual_background" : "qual_background";
    return [
        ColumnRankRowSpan({}),
        ColumnNocRowSpan({}),
        ColumnNameRowSpan({ type: type, headerClassName: nameHeaderClassName }),
        ColumnExtendedResultRowSpan({ id: "RankOpening", label: "HeaderOpeningSeriesRank", code: "OPENING" }),
        ColumnQualificationRowSpan({ headerClassName: qualHeaderClassName, className: qualClassName }),
        ColumnRacesColspan({ races: races, isMedalSeries: isMedalSeries, headerClassName: racesHeaderClassName })

    ]
}
